<p class="date-time-range-zone-label">
  {{ startDate | date: 'EEEE' }},&nbsp; {{ startDate | date: 'MMMM d' }},&nbsp;
  {{ startDate | date: 'h:mm a' }}&nbsp;-&nbsp;{{ endDate | date: 'h:mm a' }},&nbsp;
  <span *ngIf="timezone; else elseBlock">{{ timezone }}</span>
  <ng-template #elseBlock>{{ startDate | date: 'zzz' }}</ng-template>
</p>
